var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_6_6535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0482 11.0737L15 14.0248L14.0248 15L11.0737 12.0482C9.9757 12.9285 8.60993 13.4072 7.20262 13.4052C3.77877 13.4052 1 10.6265 1 7.20262C1 3.77877 3.77877 1 7.20262 1C10.6265 1 13.4052 3.77877 13.4052 7.20262C13.4072 8.60993 12.9285 9.9757 12.0482 11.0737ZM10.6657 10.5624C11.5404 9.66291 12.0289 8.45722 12.0269 7.20262C12.0269 4.53687 9.86768 2.37836 7.20262 2.37836C4.53687 2.37836 2.37836 4.53687 2.37836 7.20262C2.37836 9.86768 4.53687 12.0269 7.20262 12.0269C8.45722 12.0289 9.66291 11.5404 10.5624 10.6657L10.6657 10.5624Z",
    fill: "#636363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_6535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ca12d7147ecf9a3a195d91acacacf71e.svg";
export { ForwardRef as ReactComponent };